import { createContext } from 'react';

const DragDropContext = createContext(undefined);

export default DragDropContext;
